import React, { Component } from "react";
import style from "./style.module.scss";
import { Row, Col, Container, Table } from "reactstrap";
import PropTypes from "prop-types";
import CircularProgress from "../../../CircularProgress/CircularProgress";

const Grid = ({ crossReferences, loading, Link }) => {
  return (
    <div key="2" className={`content ${style.desk}`}>
      <Table className={style.table}>
        <thead>
          <tr>
            <th>Id</th>
            <th>Main Process</th>
            <th>Main Process Id</th>
            <th>Main Sub Process Id</th>
          </tr>
        </thead>
        <tbody>
          {crossReferences.length == 0 ? (
            <EmptyTable loading={loading} />
          ) : (
            crossReferences.map((cross, index) => (
              <tr
                className={style.rowStyle}
                key={`infinite-scroll-${cross.id}`}
                data-id={cross.id}
                data-process={cross.mainProcess}
              >
                <td>
                  <Link to={`/crossReference/${cross.mainProcess}/${cross.mainProcessId}`}>{cross.id}</Link>
                </td>
                <td>
                  <Link to={`/crossReference/${cross.mainProcess}/${cross.mainProcessId}`}>
                    {cross.mainProcess}
                  </Link>
                </td>
                <td>
                  <Link to={`/crossReference/${cross.mainProcess}/${cross.mainProcessId}`}>
                    {cross.mainProcessId}
                  </Link>
                </td>
                <td>
                  <Link to={`/crossReference/${cross.mainProcess}/${cross.mainProcessId}`}>
                    {cross.mainSubProcessId}
                  </Link>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

const EmptyTable = ({ loading }) => (
  <tr>
    <td colSpan="8" style={{ textAlign: "center", padding: "40px" }}>
      {loading ? (
        <CircularProgress style={{ marginTop: "10%" }} />
      ) : (
        <h4 style={{ textAlign: "center" }}>No CrossReferences</h4>
      )}
    </td>
  </tr>
);

Grid.propTypes = {
  crossReferences: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  Link: PropTypes.any.isRequired,
};

export default Grid;
